module.exports = __webpack_public_path__ + "img/info_ico_shopx.030ba44.png";